/**
 * 安全的 Toast 包装函数，处理 React 兼容性问题
 */

// 定义 Toast 选项接口
interface ToastOptions {
  icon?: 'success' | 'fail' | 'loading';
  content: string;
  duration?: number;
}

/**
 * 安全的 Toast 显示函数
 * 只在客户端环境下调用 antd-mobile 的 Toast
 */
export const safeToast = {
  show: (options: ToastOptions) => {
    // 确保在客户端环境
    if (typeof window !== 'undefined') {
      try {
        // 动态导入 antd-mobile 的 Toast
        import('antd-mobile').then(({ Toast }) => {
          Toast.show(options);
        }).catch((error) => {
          console.error('Toast 加载失败:', error);
          // 备选方案：使用原生 alert
          alert(options.content);
        });
      } catch (error) {
        console.error('Toast 显示失败:', error);
        // 备选方案：使用原生 alert
        alert(options.content);
      }
    } else {
      // 服务端环境，只在控制台输出
      console.log('Toast (服务端):', options.content);
    }
  },

  success: (content: string) => {
    safeToast.show({
      icon: 'success',
      content,
    });
  },

  error: (content: string) => {
    safeToast.show({
      icon: 'fail',
      content,
    });
  },

  loading: (content: string) => {
    safeToast.show({
      icon: 'loading',
      content,
    });
  },
}; 